import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityInvitationsResendPostAsyncSlice } from './post';

export const securityInvitationsResendReducers = combineReducers({
	post: securityInvitationsResendPostAsyncSlice.asyncReducers
});

export const securityInvitationsResendWatchers = combineAllWatchers([
	securityInvitationsResendPostAsyncSlice.asyncWatchers
]);
